export default __webpack_public_path__ + "static/media/MyRiadPro-SemiBold.662f3601.OTF";